
const BASE_URL = "https://magsm.tn";

export default BASE_URL;
